import React from "react"
import Service from './wallet.service'
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import './wallet.styles.scss'
import NumberFormat from "react-number-format"

class Wallet extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    componentDidMount() {
        this.service.loadWallet()
    }

    render() {
        return (
            <>
                {(this.state.loadingWallet || this.state.creatingDvn) && <Dialog><Loading /></Dialog>}
                <div className="wallet">
                    <div className="header">
                        <h1>My Wallet</h1>
                        <p>A secure, dedicated bank account within the association.</p>
                    </div>
                    <div className="details">
                        <div className="wallet-info">
                            <div className="wallet-balance-group">
                                <span>Current Wallet Balance</span>
                                <p className="wallet-info-text">₦<NumberFormat value={this.state.wallet.balance} displayType={'text'} thousandSeparator={true} renderText={value => value} /></p>
                            </div>
                        </div>

                        <div className="section-header">
                            <h4>How to Fund Wallet</h4>
                        </div>

                        <div>
                            {this.state.wallet.dvn === null && <button onClick={this.service.createDvn}>Generate</button>}
                        </div>

                        {
                            this.state.wallet.dvn !== null &&
                            <>
                                <p className="note">
                                    Transfer funds into the following account details
                                </p>
                                <div className="funding-source">
                                    <p>Account Name: <strong>{this.state.wallet.dvn.accountName}</strong></p>
                                    <p>Account Number: <strong>{this.state.wallet.dvn.accountNumber}</strong></p>
                                    <p>Bank: <strong>{this.state.wallet.dvn.bank}</strong></p>
                                </div>
                                <button id="final-pay-button" className="final-pay-button" onClick={this.service.loadWallet}>
                                    Reload Wallet
                                </button>
                            </>
                        }
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(Wallet))